import type { RouteObject } from "react-router-dom";

import { IndexWrapper } from "@framework/shared";

import { RaffleSection } from "../../../dashboard/mechanics/raffle";
import { PredictionQuestion } from "./question";

export const predictionRoutes: Array<RouteObject> = [
  {
    path: "/prediction",
    children: [
      {
        index: true,
        element: (
          <IndexWrapper index="prediction">
            <RaffleSection />
          </IndexWrapper>
        ),
      },
      {
        path: "/prediction/question",
        children: [
          { index: true, element: <PredictionQuestion /> },

          { path: "/prediction/question/:id/:action", element: <PredictionQuestion /> },
        ],
      },
    ],
  },
];
